module.exports = __webpack_public_path__ + "static/21-13c543cec9fac01bb7262e442e468151.jpg";